import styled from 'styled-components';

import { colors, functions } from '../../ui/variables';

export const GraphicLungStyle = styled.svg`
  .lung-part {
    cursor: pointer;
    fill: ${functions.rgba(colors.darkModerateBlue, 0.25)};
    transition: fill 600ms;
  }

  &.classification-normal {
    .lung-part {
      &.active {
        fill: ${functions.rgba(colors.softBlue, 0.5)};
      }
    }
  }

  &.classification-high {
    .lung-part {
      &.active {
        fill: ${functions.rgba(colors.softYellow, 0.5)};
      }
    }
  }

  &.classification-low {
    .lung-part {
      &.active {
        fill: ${functions.rgba(colors.softRed, 0.5)};
      }
    }
  }
`;
